/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Sidenav from "./common/Sidenav";
import Configurator from "./common/Configurator";
import theme from "./assets/theme";
import themeDark from "./assets/theme-dark";
// import routes from "routes";

import { useMaterialUIController, setMiniSidenav } from "context";

import brandWhite from "assets/images/logo-white.png";
import brandDark from "assets/images/logo-dark.png";
import { withAuthGuard } from "./hocs/with-auth-guard";
import {  useSelector } from "react-redux";
import useData from "routes";


const AppContent = withAuthGuard(() => {
  const routes = useData()
  const [controller, dispatch] = useMaterialUIController();
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const {
    miniSidenav,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  return (<>
    {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName=""
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {/* {configsButton} */}
        </>
      )}
      {layout === "vr" && <Configurator />}
  </>)
})

const App = () => {
    const routes = useData()
    const [controller] = useMaterialUIController();
    const user = useSelector(store => store.user)
   
    const {
      direction,
      darkMode,
    } = controller;
  
    const { pathname } = useLocation();

    useEffect(() => {
      document.body.setAttribute("dir", direction);
    }, [direction]);

    useEffect(() => {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }, [pathname]);

    const getRoutes = (allRoutes) => allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
    if (!user.loaded) {
      return ""
    }
    return (
      <ThemeProvider theme={darkMode ? themeDark : theme}>
          <Routes>
            {getRoutes(routes)}
          </Routes>
          <CssBaseline />
          <AppContent />
      </ThemeProvider>
    );
};

export default App;